__turbopack_context__.v({
  "hands": "noz-input-peek-module__zOgisG__hands",
  "head": "noz-input-peek-module__zOgisG__head",
  "isLive": "noz-input-peek-module__zOgisG__isLive",
  "nozInputBob": "noz-input-peek-module__zOgisG__nozInputBob",
  "nozInputHands": "noz-input-peek-module__zOgisG__nozInputHands",
  "nozInputPeek": "noz-input-peek-module__zOgisG__nozInputPeek",
  "peek": "noz-input-peek-module__zOgisG__peek",
  "pupil": "noz-input-peek-module__zOgisG__pupil",
  "wrap": "noz-input-peek-module__zOgisG__wrap",
});
